<template>
  <div
    class="in_tgbox"
    :style="
      'background-image:url(' +
      require('../../../assets/images/bg_1.png') +
      ');'
    "
  >
    <!-- 托管业务 start  -->
    <div class="custody_business_d" >
      <in-title
        :titletxt="lange == 'ch' ? obj.inTitle2.ch : obj.inTitle2.en"
        colors="color:#fff;"
        xiancolor="background-color:#bcc3c9;"
        zong="0"
      />
    </div>
    <div class="center">
      <div class="wow bounceInLeft  animated in_tg_1" data-wow-delay="0.2s">
        <div class="in_tg_1_1" style="margin: 0 0 30px 37%">
          <img class="in_tg_1Img" src="@/assets/images/inz_ico_1.png" />
          <div
            class="in_tg_1Title"
            v-if="lange == 'ch'"
            v-html="obj.intg1.title.ch"
          ></div>
          <div class="in_tg_1Title" v-else v-html="obj.intg1.title.en"></div>
          <div
            class="in_tg_1Conact"
            v-if="lange == 'ch'"
            v-html="obj.intg1.cat.ch"
          ></div>
          <div class="in_tg_1Conact" v-else v-html="obj.intg1.cat.en"></div>
        </div>
      </div>

      <div
        class="  in_tg_1"
        style="display: flex; justify-content: space-between"
      >
        <div class="wow bounceInLeft  animated in_tg_1_1" data-wow-delay="0.4s">
          <img class="in_tg_1Img" src="@/assets/images/inz_ico_2.png" />
          <div
            class="in_tg_1Title"
            v-if="lange == 'ch'"
            v-html="obj.intg2.title.ch"
          ></div>
          <div class="in_tg_1Title" v-else v-html="obj.intg2.title.en"></div>
          <div
            class="in_tg_1Conact"
            v-if="lange == 'ch'"
            v-html="obj.intg2.cat.ch"
          ></div>
          <div class="in_tg_1Conact" v-else v-html="obj.intg2.cat.en"></div>
        </div>
        <div id="zlogo" class="wow bounceInLeft  animated in_tg_1_1" data-wow-delay="0.6s" style="margin-top: 66px">
          <img class="in_tg_1Img" src="@/assets/images/inz_ico_4.png" />
          <div
            class="in_tg_1Title"
            style="font-weight: 400; margin: 10px 0 0 0"
          >
            {{ lange == "ch" ? obj.intg3.cat.ch : obj.intg3.cat.en }}
          </div>
          <div class="in_tg_1Title">
            {{ lange == "ch" ? obj.intg3.title.ch : obj.intg3.title.en }}
          </div>
          <div class="in_tg_1Conact"></div>
        </div>
        <div class=" wow bounceInLeft  animated in_tg_1_1" data-wow-delay="0.8s">
          <img class="in_tg_1Img" src="@/assets/images/inz_ico_3.png" />

          <div class="in_tg_1Title" v-if="lange == 'ch'" v-html="obj.intg4.title.ch"></div>
          <div class="in_tg_1Title" v-else v-html="obj.intg4.title.en"></div>

          <div class="in_tg_1Conact" v-if="lange == 'ch'" v-html="obj.intg4.cat.ch"></div>
          <div class="in_tg_1Conact" v-else v-html="obj.intg4.cat.en"></div>

        </div>
      </div>
    </div>

    <!-- 专项业务 start  -->
    <div class="in_zxyw">
      <!-- title  -->
      <div class="zyw_1">
        <in-title
          :titletxt="lange == 'ch' ? obj.inTitle3.ch : obj.inTitle3.en"
          colors="color:#122e4f;"
          xiancolor="background-color:#1f3958;"
          zong="1"
        />
      </div>
      <div class="in_zxyw_list">
        <div
          class="wow bounceInRight animated in_zx_ls"
          v-for="(item, index) in obj.inTitle3.list"
          :key="index"
          :data-wow-delay="parseInt('0.3'*(index*1+1))"
          @click="clickShow(item)"
        >
          <img src="@/assets/images/iny_ico_1.png" />
          <span>{{ lange == "ch" ? item.ch : item.en }}</span>
        </div>
      </div>
    </div>
    <div class="div_11"></div>
    <!-- 弹窗 start -->
              <div class="tcBox" v-if="showTc" @click.stop="clickHide">
                <div
                  class="cha1"
                  :style="
                    'content: url(' + require('../../../assets/images/cha.svg') + ');'
                  "
                ></div>
                <div class="tcCnt" @click.stop="">
                  <div class="t_center">
                    <div class="div_t1">
                      <span class="con_title">{{layerShowTitle}}</span>
                    </div>
                    <div class="div_t1">
                      <span class="con_msg">{{layerShowTxt}}</span>
                    </div>

                    <div class="div_t1">
                      <div
                        class="div_t2"
                        :style="
                          'background-image:url(' +
                          require('../../../assets/images/t_c_5.png') +
                          ')'
                        "
                      >
                        <span>{{ lange == "ch" ? "姓名:" : "Name:" }}</span>
                      </div>
                      <input type="text" class="t_input" v-model="name" maxlength="16" />
                    </div>
                    <div class="div_t1">
                      <div
                        class="div_t2"
                        :style="
                          'background-image:url(' +
                          require('../../../assets/images/t_c_4.png') +
                          ')'
                        "
                      >
                        <span>{{ lange == "ch" ? "电话:" : "Tel:" }}</span>
                      </div>
                      <input type="tel" class="t_input" v-model="tel" maxlength="11" />
                    </div>
                    <div class="div_t1">
                      <div
                        class="div_t2"
                        :style="
                          'background-image:url(' +
                          require('../../../assets/images/t_c_2.png') +
                          ')'
                        "
                      >
                        <span>{{lange == "ch" ? "邮箱:" : "Email:" }}</span>
                      </div>
                      <input type="email" class="t_input" v-model="emil" maxlength="30" />
                    </div>
                    <div class="div_t1">
                      <div
                        class="div_t2"
                        :style="
                          'background-image:url(' +
                          require('../../../assets/images/t_c_1.png') +
                          ')'
                        "
                      >
                        <span>{{lange == "ch" ? "描述:" : "Eescribe:" }}</span>
                      </div>
                      <textarea v-if='lange == "ch"'
                        class="textareas"
                        placeholder='请描述您要咨询内容或业务方向'
                        v-model="textareaTxt"
                        maxlength="500"
                      ></textarea>
                      <textarea v-if='lange != "ch"'
                        class="textareas"
                        placeholder='Please describe the content or business direction you want to consult'
                        v-model="textareaTxt"
                        maxlength="500"
                      ></textarea>
                    </div>
                    <div class="btn_div">
                      <span class="btn" @click="clickBtn">{{lange == "ch" ? "提交咨询" : "Submit" }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 弹窗 end -->
  </div>
</template>

<script>
import InTitle from "./InTitle";
import '@/assets/css/ConsultingLayer.css';
import { zixForm } from "@/api/index";
import { emailYz, checkPhone } from "@/utils/utils";
export default {
  name: "InCustodyBusiness",
  components: { InTitle },
  data() {
    return { lange: this.$cookies.getCookie("language"), obj: {} ,
    showTc: false,
    name: "",
    tel: "",
    emil: "",
    textareaTxt: "",
    layerShowTxt:"",
    layerShowTitle:"",
    };
  },
  created() {
    this.obj = this.$store.state.indexText;
  },
  methods:{
    clickShow(obj) {
       if (this.showTc) {
         this.showTc = false;
         this.layerShowTxt ="";
         this.layerShowTitle="";
       } else {
         this.showTc = true;
         this.layerShowTxt = obj.layerShow_ch;
         this.layerShowTitle = obj.ch;
       }
     },
     clickBtn() {
       if (this.yanzheng(this.name, "名字")) {
         return false;
       }
       if (this.yanzheng(this.tel, "电话")) {
         return false;
       }
       if (this.yanzheng(this.emil, "邮箱")) {
         return false;
       }
       if (this.yanzheng(this.textareaTxt, "描述")) {
         return false;
       }
       this.formApi();
       this.showTc = false;
     },
     clickHide() {
       this.showTc = false;
     },
     formApi() {
       //咨询表单提交
       var data = {
         name: this.name,
         phoneNum: this.tel,
         email: this.emil,
         market: this.textareaTxt,
       };
       zixForm(data)
         .then((response) => {
           if (response.code == 0) {
             this.name = "";
             this.tel = "";
             this.emil = "";
             this.textareaTxt = "";
           }
         })
         .catch((error) => {
           console.log(error);
         });
     },
     yanzheng(a, b) {
       if (a == "") {
         this.$message({
           showClose: true,
           message: b + "不能为空",
         });
         return true;
       }
       if (b == "邮箱") {
         if (!emailYz(a)) {
           this.$message({
             showClose: true,
             message: b + "格式不正确",
           });
           return true;
         }
       }
       if (b == "电话") {
         /*if (!checkPhone(a)) {
           this.$message({
             showClose: true,
             message: b + "格式不正确",
           });
           return true;
         }*/
       }
     },
  },
  props: [""],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.in_tgbox {
  width: 100%;
  display: block;
  background-repeat: no-repeat;
  background-position: center 0;
  background-size: cover;
}
.center {
  width: 70%;
  min-height: 35px;
  display: block;
  margin: 0 auto;
  position: relative;
}
.custody_business_d{
  width: 100%;
  display: block;
  padding: 60px 0
}
.in_tg_1 {
  widows: 100%;
  display: block;
  padding-bottom: 100px;
}
.in_tg_1_1 {
  width: 26%;
  display: block;
}
.in_tg_1Img {
  width: 26%;
  display: block;
  margin: 0 0 0 37%;
}
.in_tg_1Title {
  width: 100%;
  display: block;
  font-size: 18px;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
  color: #fff;
  text-align: center;
  letter-spacing: 2px;
  margin: 10px 0 20px 0;
}
.in_tg_1Conact {
  width: 100%;
  display: block;
  text-align: center;
  font-size: 14px;
  color: #fff;
  line-height: 24px;
  /*word-break: break-all;111*/
}
/*  专项业务 */
.in_zxyw {
  width: 90%;
  display: block;
  position: relative;
  background-color: rgba(255, 255, 255, 0.6);
  margin: 0 auto;
}
.in_zxyw_list {
  width: 80%;
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  padding: 0 0 0 10%;
}
.in_zx_ls {
  width: 33%;
  display: flex;
  justify-content: space-around;
  margin-bottom: 80px;
}
.in_zx_ls > img {
  width: 26px;
  height: 26px;
  display: block;
}
.in_zx_ls > span {
  width: 80%;
  display: block;
  font-size: 16px;
  color: #02182c;
  line-height: 26px;
  font-weight: bold;
  /*word-break: break-all;111*/
}
.div_11 {
  width: 100%;
  height: 130px;
  display: block;
}
.zyw {
  width: 100%;
  display: block;
  padding: 50px 0;
}
.zyw_1 {
  padding: 50px 0;
}
@media only screen and (max-width: 1440px) {
  .center {
    width: 90%;
  }
}
@media only screen and (max-width: 768px) {
  .in_zx_ls {
    width: 50%;
  }
}
@media only screen and (max-width: 425px) {
  .in_tg_1_1 {
    width: 100%;
    display: block;
    margin: 0 !important;
    padding-bottom: 10px;
  }
  .in_tg_1 {
    flex-wrap: wrap;
    padding-bottom: 10px;
  }
  .in_zx_ls {
    width: 100%;
    margin-bottom: 30px;
  }
  .in_zx_ls > img {
    width: 15px;
    height: 15px;
    display: block;
  }
  .in_zx_ls > span {
    font-size: 14px;
    line-height: 15px;
  }
  .in_tg_1Title {
    font-size: 16px;
    margin: 10px 0;
  }
  .in_tg_1Conact {
    font-size: 12px;
    line-height: 20px;
  }
  #zlogo {
    display: none;
  }
  .div_11 {
    height: 60px;
  }
  .zyw_1 {
    padding: 30px 0 20px 0;
  }
  .custody_business_d{
    width: 100%;
    display: block;
    padding: 50px 0 35px 0;
  }
  .in_zxyw{
    margin: 20px auto 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/component/InCustodyBusiness.vue